import axios from "axios";

const SEVER_API = process.env.REACT_APP_API_URL;

export const getSendEmail = async (mailTo, subject, text, html) => {
    const sendSchema = {
        to: mailTo,
        subject,
        text,
        html
    };

    await axios.post(`${SEVER_API}/send-email`, sendSchema).then(res => {
        if (res.status === 201) {
            console.log("Email enviado com sucesso!");
        }
    }).catch(error => {
        console.error(error);
    });
};
